export default __webpack_public_path__ + "static/media/shopee3.242155c5.png";